import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { LazyLoadImage } from "react-lazy-load-image-component";
import Bannerfrom from "../components/bannerfrom";

function Banner({ data }) {
  return (
    <div className="services_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="">
                <h1>Oracle Consulting Services</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  TekRevol's Oracle consulting services enable businesses to
                  build and manage cloud applications using a business-centric
                  approach with the right tools and approaches.
                </p>
                <ul>
                  <li>Business-centric cloud engagements</li>
                  <li>Build & manage cloud apps</li>
                  <li>Oracle consulting solutions</li>
                  <li>Achieve IT objectives</li>
                </ul>
              </div>
            </div>
          </Col>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
